import React, { useEffect, useState } from "react";
import "./LoginModal.css";
import axios from "../axios";
import ContactInput from './ContactInput';
import { FaEye, FaEyeSlash } from "react-icons/fa";



function LoginModal({
  onClose,
  setUser,
  setToken,
  user,
}) {
  const fetchUser = async (token) => {
    try {
      const res = await axios.get("/api/user/", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.status === 200) {
        setUser(res.data);
        setToken(token);
      }
    } catch (err) {
      console.error("❌ Σφάλμα κατά τη φόρτωση του χρήστη:", err);
      setUser(null);
      setToken(null);
    }
  };
  const [step, setStep] = useState(1);
  const [identifier, setIdentifier] = useState(""); // телефон или email
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [mode, setMode] = useState("register");
  useEffect(() => {
    if (resendTimer <= 0) return;

    const timerId = setTimeout(() => {
      setResendTimer((prev) => Math.max(prev - 1, 0));
    }, 1000);

    return () => clearTimeout(timerId);
  }, [resendTimer]);

  const handleLoginDirect = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await axios.post("/api/token/", {
        username: identifier,  // ✅ username теперь — это email или телефон
        password,
      });

      const data = res.data;

      if (data.access && data.refresh) {
        localStorage.setItem("token", data.access);
        localStorage.setItem("refresh", data.refresh);

        setToken(data.access);
        await fetchUser(data.access);
        onClose();
        return;
      }

      // ❌ Не надо ничего писать здесь — пусть отлавливается в catch
    } catch (error) {
      console.error("❌ Σφάλμα σύνδεσης:", error);
      if (!error.response) {
        setError("⚠️ Δεν είναι δυνατή η σύνδεση με τον διακομιστή. Προσπαθήστε ξανά αργότερα.");
      } else {
        setError("❌ Λάθος στοιχεία.");
      }
    }
  };


const handleSendCode = async () => {
  if (loading) return;

  setError("");
  setLoading(true);

  try {
    await axios.post("/api/send-code/", {
      contact: identifier,
      password,
    });

    const isEmail = identifier.includes("@");
    setMessage(`✅ Ο 6-ψήφιος κωδικός εστάλη στο ${isEmail ? "email" : "τηλέφωνο"}.`);
    setStep(2);
    setResendTimer(60);
  } catch (error) {
    let msg = "❌ Σφάλμα κατά την αποστολή κωδικού.";
    const data = error?.response?.data;

    if (typeof data === "string") {
      msg = data;
    } else if (data?.non_field_errors) {
      msg = Array.isArray(data.non_field_errors)
        ? data.non_field_errors[0]
        : data.non_field_errors;
    } else if (data?.contact?.[0]) {
      msg = data.contact[0];
    } else if (Array.isArray(data) && data[0]) {
      msg = data[0];
    } else if (data?.error) {
      msg = data.error;
    }

    if (
      msg === "Ο χρήστης με αυτό το email υπάρχει ήδη. Παρακαλώ συνδεθείτε." ||
      msg === "Ο χρήστης με αυτόν τον αριθμό υπάρχει ήδη. Παρακαλώ συνδεθείτε." ||
      msg === "Ο χρήστης με αυτό το email/αριθμό υπάρχει ήδη. Παρακαλώ συνδεθείτε."
    ) {
      setError(msg);
      setIdentifier(identifier);
      setPassword(password); // 🟢 сохраняем введённый пароль
      setMode("login");

      // 🟡 Немного откладываем шаг 1, чтобы сначала применился mode
      setTimeout(() => setStep(1), 0);
    } else {
      setError(msg || "❌ Σφάλμα κατά την αποστολή κωδικού.");
    }
  } finally {
    setLoading(false);
  }
};


const handleVerifyCode = async () => {
  setLoading(true);
  setError(null);

  try {
    const res = await axios.post("/api/verify-code/", {
      contact: identifier,
      code,
      password,
    });

    const access = res.data.access;
    const refresh = res.data.refresh;
    const user = res.data.user;

    if (access && refresh && user) {
      // 💾 Сохраняем access и refresh токены
      localStorage.setItem("token", access);
      localStorage.setItem("refresh", refresh);

      // 💾 Сохраняем пользователя
      localStorage.setItem("user", JSON.stringify(user));

      // 🧹 Удаляем старый ключ "access", если он где-то остался
      localStorage.removeItem("access");

      await fetchUser(access);
      setStep(3);
      setTimeout(() => {
        onClose();
      }, 1500);
    } else {
      setError("❌ Λανθασμένος ή ληγμένος κωδικός.");
    }
  } catch (error) {
    console.error("Σφάλμα κατά την επιβεβαίωση του κωδικού:", error);
    setError("⚠️ Κάτι πήγε στραβά. Προσπαθήστε ξανά.");
  } finally {
    setLoading(false);
  }
};







return (
  <div className="modal-overlay">
    <div className="modal">
      <button className="close-modal" onClick={onClose}>✖</button>
      <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem", justifyContent: "center" }}>
  <button
    className="auth-button"
    style={{ backgroundColor: mode === "login" ? "#0077b6" : "#ccc" }}
    onClick={() => {
      setMode("login");
      setStep(1);
    }}
  >
    Είσοδος
  </button>
  <button
    className="auth-button"
    style={{ backgroundColor: mode === "register" ? "#0077b6" : "#ccc" }}
    onClick={() => {
      setMode("register");
      setStep(1);
    }}
  >
    Εγγραφή
  </button>
</div>

      {/* Шаг 1: ввод email/телефона и пароля */}
{step === 1 && (
  <form className="step step-one" onSubmit={handleLoginDirect}>
    <h2>{mode === "login" ? "Είσοδος" : "Εγγραφή"}</h2>

    <ContactInput value={identifier} onChange={setIdentifier} />

    <div style={{ position: "relative", width: "100%" }}>
      <input
        type={showPassword ? "text" : "password"}
        placeholder="Κωδικός πρόσβασης"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="contact-text-input"
        style={{ paddingRight: "40px" }}
      />
      <span
        onClick={() => setShowPassword((prev) => !prev)}
        className="eye-icon"
      >
        {showPassword ? <FaEyeSlash /> : <FaEye />}
      </span>
    </div>

    {mode === "login" && (
      <button
        type="button"
        className="forgot-password-link"
        onClick={() => {
          onClose(); // Закрываем текущую модалку
          // 🔜 После следующего шага откроем PasswordResetModal
          window.dispatchEvent(new Event("open-password-reset")); // временный способ
        }}
      >
        Ξέχασες τον κωδικό;
      </button>
    )}


    {mode === "login" ? (
      <button type="submit" className="green-button">
        Είσοδος
      </button>
    ) : (
      <button type="button" className="green-button" onClick={handleSendCode}>
        Εγγραφή
      </button>
    )}

    {error && <div className="auth-error">{error}</div>}
  </form>
)}



      {/* Шаг 2: подтверждение кода */}
      {step === 2 && (
  <div className="step">
    <p>📩 {message}</p>
    <input
      type="text"
      placeholder="6-ψήφιος κωδικός"
      value={code}
      onChange={(e) => setCode(e.target.value)}
    />
    <div className="code-actions">
      <button
        className="green-button"
        onClick={handleVerifyCode}
        disabled={loading}
      >
        {loading ? "Έλεγχος..." : "Επιβεβαίωση"}
      </button>
      <button
        className="resend-button"
        onClick={handleSendCode}
        disabled={loading || resendTimer > 0}
      >
        {loading
          ? "Αποστολή..."
          : resendTimer > 0
            ? `Αποστολή ξανά σε ${resendTimer}s`
            : "Αποστολή ξανά"}
      </button>
    </div>
  </div>
)}

      {/* Шаг 3: успешный вход */}
      {step === 3 && (
        <div className="success-message">
          Επιτυχής σύνδεση!
        </div>
      )}
    </div>
  </div>
);
}

export default LoginModal;
